<template>
  <section class="section promo-section light-bg">
    <div class="container">
      <div class="process">
        <h2 class="title title--center title--mb">Схема процесса</h2>
        <ul class="process__list">
          <li v-for="item in list" class="process__item" :key="item.id" data-aos="fade-up" data-aos-duration="800" data-aos-delay="0">
            <nuxt-img class="process__img" :src="item.icon" :alt="item.title" />
            <h3 class="title title-s4">
              <span>{{ item.id }}. </span>{{ item.title }}
            </h3>
            <p class="text text--dark">{{ item.text }}</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
const list = [
  {
    id: 1,
    title: 'Покупка',
    text: 'Вы приобретаете системуTERPO',
    icon: '/img/support/icon_1.png',
  },
  {
    id: 2,
    title: 'Установка',
    text: 'Мы устанавливаем систему на сервер',
    icon: '/img/support/icon_2.png',
  },
  {
    id: 3,
    title: 'Работа',
    text: 'Вы используете систему в ежедневной работе',
    icon: '/img/support/icon_3.png',
  },
  {
    id: 4,
    title: 'Обновления',
    text: 'Мы выпускаем новые версии, исправляем ошибки и улучшаем',
    icon: '/img/support/icon_4.png',
  },
];
</script>

<style scoped lang="scss">
@use '~/assets/styles/mixins';
.process {
  &__list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-align: center;
  }

  &__img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
}

@media (max-width: 1024px) {
  .process {
    &__list {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 500px) {
  .process {
    &__list {
      grid-template-columns: 1fr;
    }
  }
}
</style>
